/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthYoutubeCallbackRouteImport } from './routes/auth.youtube-callback'
import { Route as AuthGscCallbackRouteImport } from './routes/auth.gsc-callback'
import { Route as AuthenticatedUstawieniaRouteImport } from './routes/_authenticated/ustawienia'
import { Route as AuthenticatedProjektyRouteImport } from './routes/_authenticated/projekty'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedProjektyIndexRouteImport } from './routes/_authenticated/projekty.index'
import { Route as AuthenticatedProjektyNowyRouteImport } from './routes/_authenticated/projekty.nowy'
import { Route as AuthenticatedProjektyProjectIdRouteImport } from './routes/_authenticated/projekty.$projectId'
import { Route as AuthenticatedProjektyProjectIdIndexRouteImport } from './routes/_authenticated/projekty.$projectId.index'
import { Route as AuthenticatedProjektyProjectIdYoutubeSeoRouteImport } from './routes/_authenticated/projekty.$projectId.youtube-seo'
import { Route as AuthenticatedProjektyProjectIdUstawieniaRouteImport } from './routes/_authenticated/projekty.$projectId.ustawienia'
import { Route as AuthenticatedProjektyProjectIdSerpRouteImport } from './routes/_authenticated/projekty.$projectId.serp'
import { Route as AuthenticatedProjektyProjectIdRaportSeoRouteImport } from './routes/_authenticated/projekty.$projectId.raport-seo'
import { Route as AuthenticatedProjektyProjectIdGscRouteImport } from './routes/_authenticated/projekty.$projectId.gsc'
import { Route as AuthenticatedProjektyProjectIdColdStartRouteImport } from './routes/_authenticated/projekty.$projectId.cold-start'
import { Route as AuthenticatedProjektyProjectIdAudytRouteImport } from './routes/_authenticated/projekty.$projectId.audyt'
import { Route as AuthenticatedProjektyProjectIdAlertyRouteImport } from './routes/_authenticated/projekty.$projectId.alerty'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthYoutubeCallbackRoute = AuthYoutubeCallbackRouteImport.update({
  id: '/auth/youtube-callback',
  path: '/auth/youtube-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGscCallbackRoute = AuthGscCallbackRouteImport.update({
  id: '/auth/gsc-callback',
  path: '/auth/gsc-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUstawieniaRoute = AuthenticatedUstawieniaRouteImport.update({
  id: '/ustawienia',
  path: '/ustawienia',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjektyRoute = AuthenticatedProjektyRouteImport.update({
  id: '/projekty',
  path: '/projekty',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjektyIndexRoute =
  AuthenticatedProjektyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjektyRoute,
  } as any)
const AuthenticatedProjektyNowyRoute =
  AuthenticatedProjektyNowyRouteImport.update({
    id: '/nowy',
    path: '/nowy',
    getParentRoute: () => AuthenticatedProjektyRoute,
  } as any)
const AuthenticatedProjektyProjectIdRoute =
  AuthenticatedProjektyProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedProjektyRoute,
  } as any)
const AuthenticatedProjektyProjectIdIndexRoute =
  AuthenticatedProjektyProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdYoutubeSeoRoute =
  AuthenticatedProjektyProjectIdYoutubeSeoRouteImport.update({
    id: '/youtube-seo',
    path: '/youtube-seo',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdUstawieniaRoute =
  AuthenticatedProjektyProjectIdUstawieniaRouteImport.update({
    id: '/ustawienia',
    path: '/ustawienia',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdSerpRoute =
  AuthenticatedProjektyProjectIdSerpRouteImport.update({
    id: '/serp',
    path: '/serp',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdRaportSeoRoute =
  AuthenticatedProjektyProjectIdRaportSeoRouteImport.update({
    id: '/raport-seo',
    path: '/raport-seo',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdGscRoute =
  AuthenticatedProjektyProjectIdGscRouteImport.update({
    id: '/gsc',
    path: '/gsc',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdColdStartRoute =
  AuthenticatedProjektyProjectIdColdStartRouteImport.update({
    id: '/cold-start',
    path: '/cold-start',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdAudytRoute =
  AuthenticatedProjektyProjectIdAudytRouteImport.update({
    id: '/audyt',
    path: '/audyt',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)
const AuthenticatedProjektyProjectIdAlertyRoute =
  AuthenticatedProjektyProjectIdAlertyRouteImport.update({
    id: '/alerty',
    path: '/alerty',
    getParentRoute: () => AuthenticatedProjektyProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/projekty': typeof AuthenticatedProjektyRouteWithChildren
  '/ustawienia': typeof AuthenticatedUstawieniaRoute
  '/auth/gsc-callback': typeof AuthGscCallbackRoute
  '/auth/youtube-callback': typeof AuthYoutubeCallbackRoute
  '/projekty/$projectId': typeof AuthenticatedProjektyProjectIdRouteWithChildren
  '/projekty/nowy': typeof AuthenticatedProjektyNowyRoute
  '/projekty/': typeof AuthenticatedProjektyIndexRoute
  '/projekty/$projectId/alerty': typeof AuthenticatedProjektyProjectIdAlertyRoute
  '/projekty/$projectId/audyt': typeof AuthenticatedProjektyProjectIdAudytRoute
  '/projekty/$projectId/cold-start': typeof AuthenticatedProjektyProjectIdColdStartRoute
  '/projekty/$projectId/gsc': typeof AuthenticatedProjektyProjectIdGscRoute
  '/projekty/$projectId/raport-seo': typeof AuthenticatedProjektyProjectIdRaportSeoRoute
  '/projekty/$projectId/serp': typeof AuthenticatedProjektyProjectIdSerpRoute
  '/projekty/$projectId/ustawienia': typeof AuthenticatedProjektyProjectIdUstawieniaRoute
  '/projekty/$projectId/youtube-seo': typeof AuthenticatedProjektyProjectIdYoutubeSeoRoute
  '/projekty/$projectId/': typeof AuthenticatedProjektyProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/ustawienia': typeof AuthenticatedUstawieniaRoute
  '/auth/gsc-callback': typeof AuthGscCallbackRoute
  '/auth/youtube-callback': typeof AuthYoutubeCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/projekty/nowy': typeof AuthenticatedProjektyNowyRoute
  '/projekty': typeof AuthenticatedProjektyIndexRoute
  '/projekty/$projectId/alerty': typeof AuthenticatedProjektyProjectIdAlertyRoute
  '/projekty/$projectId/audyt': typeof AuthenticatedProjektyProjectIdAudytRoute
  '/projekty/$projectId/cold-start': typeof AuthenticatedProjektyProjectIdColdStartRoute
  '/projekty/$projectId/gsc': typeof AuthenticatedProjektyProjectIdGscRoute
  '/projekty/$projectId/raport-seo': typeof AuthenticatedProjektyProjectIdRaportSeoRoute
  '/projekty/$projectId/serp': typeof AuthenticatedProjektyProjectIdSerpRoute
  '/projekty/$projectId/ustawienia': typeof AuthenticatedProjektyProjectIdUstawieniaRoute
  '/projekty/$projectId/youtube-seo': typeof AuthenticatedProjektyProjectIdYoutubeSeoRoute
  '/projekty/$projectId': typeof AuthenticatedProjektyProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/projekty': typeof AuthenticatedProjektyRouteWithChildren
  '/_authenticated/ustawienia': typeof AuthenticatedUstawieniaRoute
  '/auth/gsc-callback': typeof AuthGscCallbackRoute
  '/auth/youtube-callback': typeof AuthYoutubeCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/projekty/$projectId': typeof AuthenticatedProjektyProjectIdRouteWithChildren
  '/_authenticated/projekty/nowy': typeof AuthenticatedProjektyNowyRoute
  '/_authenticated/projekty/': typeof AuthenticatedProjektyIndexRoute
  '/_authenticated/projekty/$projectId/alerty': typeof AuthenticatedProjektyProjectIdAlertyRoute
  '/_authenticated/projekty/$projectId/audyt': typeof AuthenticatedProjektyProjectIdAudytRoute
  '/_authenticated/projekty/$projectId/cold-start': typeof AuthenticatedProjektyProjectIdColdStartRoute
  '/_authenticated/projekty/$projectId/gsc': typeof AuthenticatedProjektyProjectIdGscRoute
  '/_authenticated/projekty/$projectId/raport-seo': typeof AuthenticatedProjektyProjectIdRaportSeoRoute
  '/_authenticated/projekty/$projectId/serp': typeof AuthenticatedProjektyProjectIdSerpRoute
  '/_authenticated/projekty/$projectId/ustawienia': typeof AuthenticatedProjektyProjectIdUstawieniaRoute
  '/_authenticated/projekty/$projectId/youtube-seo': typeof AuthenticatedProjektyProjectIdYoutubeSeoRoute
  '/_authenticated/projekty/$projectId/': typeof AuthenticatedProjektyProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/projekty'
    | '/ustawienia'
    | '/auth/gsc-callback'
    | '/auth/youtube-callback'
    | '/projekty/$projectId'
    | '/projekty/nowy'
    | '/projekty/'
    | '/projekty/$projectId/alerty'
    | '/projekty/$projectId/audyt'
    | '/projekty/$projectId/cold-start'
    | '/projekty/$projectId/gsc'
    | '/projekty/$projectId/raport-seo'
    | '/projekty/$projectId/serp'
    | '/projekty/$projectId/ustawienia'
    | '/projekty/$projectId/youtube-seo'
    | '/projekty/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admin'
    | '/ustawienia'
    | '/auth/gsc-callback'
    | '/auth/youtube-callback'
    | '/'
    | '/projekty/nowy'
    | '/projekty'
    | '/projekty/$projectId/alerty'
    | '/projekty/$projectId/audyt'
    | '/projekty/$projectId/cold-start'
    | '/projekty/$projectId/gsc'
    | '/projekty/$projectId/raport-seo'
    | '/projekty/$projectId/serp'
    | '/projekty/$projectId/ustawienia'
    | '/projekty/$projectId/youtube-seo'
    | '/projekty/$projectId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/admin'
    | '/_authenticated/projekty'
    | '/_authenticated/ustawienia'
    | '/auth/gsc-callback'
    | '/auth/youtube-callback'
    | '/_authenticated/'
    | '/_authenticated/projekty/$projectId'
    | '/_authenticated/projekty/nowy'
    | '/_authenticated/projekty/'
    | '/_authenticated/projekty/$projectId/alerty'
    | '/_authenticated/projekty/$projectId/audyt'
    | '/_authenticated/projekty/$projectId/cold-start'
    | '/_authenticated/projekty/$projectId/gsc'
    | '/_authenticated/projekty/$projectId/raport-seo'
    | '/_authenticated/projekty/$projectId/serp'
    | '/_authenticated/projekty/$projectId/ustawienia'
    | '/_authenticated/projekty/$projectId/youtube-seo'
    | '/_authenticated/projekty/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthGscCallbackRoute: typeof AuthGscCallbackRoute
  AuthYoutubeCallbackRoute: typeof AuthYoutubeCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/youtube-callback': {
      id: '/auth/youtube-callback'
      path: '/auth/youtube-callback'
      fullPath: '/auth/youtube-callback'
      preLoaderRoute: typeof AuthYoutubeCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/gsc-callback': {
      id: '/auth/gsc-callback'
      path: '/auth/gsc-callback'
      fullPath: '/auth/gsc-callback'
      preLoaderRoute: typeof AuthGscCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/ustawienia': {
      id: '/_authenticated/ustawienia'
      path: '/ustawienia'
      fullPath: '/ustawienia'
      preLoaderRoute: typeof AuthenticatedUstawieniaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projekty': {
      id: '/_authenticated/projekty'
      path: '/projekty'
      fullPath: '/projekty'
      preLoaderRoute: typeof AuthenticatedProjektyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projekty/': {
      id: '/_authenticated/projekty/'
      path: '/'
      fullPath: '/projekty/'
      preLoaderRoute: typeof AuthenticatedProjektyIndexRouteImport
      parentRoute: typeof AuthenticatedProjektyRoute
    }
    '/_authenticated/projekty/nowy': {
      id: '/_authenticated/projekty/nowy'
      path: '/nowy'
      fullPath: '/projekty/nowy'
      preLoaderRoute: typeof AuthenticatedProjektyNowyRouteImport
      parentRoute: typeof AuthenticatedProjektyRoute
    }
    '/_authenticated/projekty/$projectId': {
      id: '/_authenticated/projekty/$projectId'
      path: '/$projectId'
      fullPath: '/projekty/$projectId'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdRouteImport
      parentRoute: typeof AuthenticatedProjektyRoute
    }
    '/_authenticated/projekty/$projectId/': {
      id: '/_authenticated/projekty/$projectId/'
      path: '/'
      fullPath: '/projekty/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/youtube-seo': {
      id: '/_authenticated/projekty/$projectId/youtube-seo'
      path: '/youtube-seo'
      fullPath: '/projekty/$projectId/youtube-seo'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdYoutubeSeoRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/ustawienia': {
      id: '/_authenticated/projekty/$projectId/ustawienia'
      path: '/ustawienia'
      fullPath: '/projekty/$projectId/ustawienia'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdUstawieniaRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/serp': {
      id: '/_authenticated/projekty/$projectId/serp'
      path: '/serp'
      fullPath: '/projekty/$projectId/serp'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdSerpRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/raport-seo': {
      id: '/_authenticated/projekty/$projectId/raport-seo'
      path: '/raport-seo'
      fullPath: '/projekty/$projectId/raport-seo'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdRaportSeoRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/gsc': {
      id: '/_authenticated/projekty/$projectId/gsc'
      path: '/gsc'
      fullPath: '/projekty/$projectId/gsc'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdGscRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/cold-start': {
      id: '/_authenticated/projekty/$projectId/cold-start'
      path: '/cold-start'
      fullPath: '/projekty/$projectId/cold-start'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdColdStartRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/audyt': {
      id: '/_authenticated/projekty/$projectId/audyt'
      path: '/audyt'
      fullPath: '/projekty/$projectId/audyt'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdAudytRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
    '/_authenticated/projekty/$projectId/alerty': {
      id: '/_authenticated/projekty/$projectId/alerty'
      path: '/alerty'
      fullPath: '/projekty/$projectId/alerty'
      preLoaderRoute: typeof AuthenticatedProjektyProjectIdAlertyRouteImport
      parentRoute: typeof AuthenticatedProjektyProjectIdRoute
    }
  }
}

interface AuthenticatedProjektyProjectIdRouteChildren {
  AuthenticatedProjektyProjectIdAlertyRoute: typeof AuthenticatedProjektyProjectIdAlertyRoute
  AuthenticatedProjektyProjectIdAudytRoute: typeof AuthenticatedProjektyProjectIdAudytRoute
  AuthenticatedProjektyProjectIdColdStartRoute: typeof AuthenticatedProjektyProjectIdColdStartRoute
  AuthenticatedProjektyProjectIdGscRoute: typeof AuthenticatedProjektyProjectIdGscRoute
  AuthenticatedProjektyProjectIdRaportSeoRoute: typeof AuthenticatedProjektyProjectIdRaportSeoRoute
  AuthenticatedProjektyProjectIdSerpRoute: typeof AuthenticatedProjektyProjectIdSerpRoute
  AuthenticatedProjektyProjectIdUstawieniaRoute: typeof AuthenticatedProjektyProjectIdUstawieniaRoute
  AuthenticatedProjektyProjectIdYoutubeSeoRoute: typeof AuthenticatedProjektyProjectIdYoutubeSeoRoute
  AuthenticatedProjektyProjectIdIndexRoute: typeof AuthenticatedProjektyProjectIdIndexRoute
}

const AuthenticatedProjektyProjectIdRouteChildren: AuthenticatedProjektyProjectIdRouteChildren =
  {
    AuthenticatedProjektyProjectIdAlertyRoute:
      AuthenticatedProjektyProjectIdAlertyRoute,
    AuthenticatedProjektyProjectIdAudytRoute:
      AuthenticatedProjektyProjectIdAudytRoute,
    AuthenticatedProjektyProjectIdColdStartRoute:
      AuthenticatedProjektyProjectIdColdStartRoute,
    AuthenticatedProjektyProjectIdGscRoute:
      AuthenticatedProjektyProjectIdGscRoute,
    AuthenticatedProjektyProjectIdRaportSeoRoute:
      AuthenticatedProjektyProjectIdRaportSeoRoute,
    AuthenticatedProjektyProjectIdSerpRoute:
      AuthenticatedProjektyProjectIdSerpRoute,
    AuthenticatedProjektyProjectIdUstawieniaRoute:
      AuthenticatedProjektyProjectIdUstawieniaRoute,
    AuthenticatedProjektyProjectIdYoutubeSeoRoute:
      AuthenticatedProjektyProjectIdYoutubeSeoRoute,
    AuthenticatedProjektyProjectIdIndexRoute:
      AuthenticatedProjektyProjectIdIndexRoute,
  }

const AuthenticatedProjektyProjectIdRouteWithChildren =
  AuthenticatedProjektyProjectIdRoute._addFileChildren(
    AuthenticatedProjektyProjectIdRouteChildren,
  )

interface AuthenticatedProjektyRouteChildren {
  AuthenticatedProjektyProjectIdRoute: typeof AuthenticatedProjektyProjectIdRouteWithChildren
  AuthenticatedProjektyNowyRoute: typeof AuthenticatedProjektyNowyRoute
  AuthenticatedProjektyIndexRoute: typeof AuthenticatedProjektyIndexRoute
}

const AuthenticatedProjektyRouteChildren: AuthenticatedProjektyRouteChildren = {
  AuthenticatedProjektyProjectIdRoute:
    AuthenticatedProjektyProjectIdRouteWithChildren,
  AuthenticatedProjektyNowyRoute: AuthenticatedProjektyNowyRoute,
  AuthenticatedProjektyIndexRoute: AuthenticatedProjektyIndexRoute,
}

const AuthenticatedProjektyRouteWithChildren =
  AuthenticatedProjektyRoute._addFileChildren(
    AuthenticatedProjektyRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedProjektyRoute: typeof AuthenticatedProjektyRouteWithChildren
  AuthenticatedUstawieniaRoute: typeof AuthenticatedUstawieniaRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedProjektyRoute: AuthenticatedProjektyRouteWithChildren,
  AuthenticatedUstawieniaRoute: AuthenticatedUstawieniaRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthGscCallbackRoute: AuthGscCallbackRoute,
  AuthYoutubeCallbackRoute: AuthYoutubeCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
